import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { Navbar } from '../components/Navbar';
import { motion } from 'motion/react';

export const AdminLayout = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
      <Sidebar />
      
      <div className="ml-64 flex flex-col min-h-screen">
        <Navbar />
        
        <main className="flex-1 p-8 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <Outlet />
          </motion.div>
        </main>

        <footer className="px-8 py-6 text-center text-slate-400 text-[10px] font-medium uppercase tracking-widest border-t border-slate-200">
          &copy; {new Date().getFullYear()} APM - Painel Administrativo de Emendas Parlamentares
        </footer>
      </div>
    </div>
  );
};
